import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { Payroll } from '@/features/payroll'

const payrollSearchSchema = z.object({
  status: z.enum(['draft', 'calculated', 'synced_to_xero', 'finalized']).optional(),
})

export const Route = createFileRoute('/_authenticated/_organization/payroll/')({
  beforeLoad: async () => requireRoles(['owner', 'admin', 'finance']),
  validateSearch: payrollSearchSchema,
  component: Payroll,
})
